import { common } from './common.icons';

export const IconFire = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 16 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-fire ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M15.48 12.3712C13.82 8.05121 7.65 8.00121 9.99 0.991211C5.52 3.00121 1.98 8.17121 5.48 15.0012C0.53 12.9212 2.7 7.71121 2.7 7.71121C2.7 7.71121 0 9.37121 0 14.3912C0.38 19.9912 5.11 21.7112 6.81 21.9312C9.24 22.2412 11.87 21.7912 13.76 20.0612C15.84 18.1312 16.6 15.0512 15.48 12.3712ZM6.2 17.4012C7.64 17.0512 8.38 16.0112 8.58 15.0912C8.91 13.6612 7.62 12.2612 8.49 10.0012C8.82 11.8712 11.76 13.0412 11.76 15.0812C11.84 17.6112 9.1 19.7812 6.2 17.4012Z"
        fill="currentColor"
      />
    </svg>
  );
};
